module.exports = __webpack_public_path__ + "media/images/subject_img/DATA SCIENCE-d1714b505d1f2c0dbd2b3b396d9f70d3.jpg";